import React, { Fragment } from 'react';
import classnames from 'classnames';
import { translate } from 'react-i18next';
import { formatTimeStamp } from 'lib/util';

const AssetFormHistoricRow = ({
  locations,
  record,
  t,
  handleToggleCollapsed,
  handleAccept,
  handleReject,
  isSaving,
  collapsed,
}) => {
  const locationParser = (value, diff) => {
    if (value == '' || !value) return '';
    return value
      .split('.')
      .map((p) => locations[p] && locations[p].name)
      .filter((l) => l)
      .join(' <br/> ');
  };
  return (
    <Fragment>
      <tr>
        <td>{formatTimeStamp(record.createdAt)}</td>
        <td>
          {record._createdBy
            ? `${record._createdBy.name} ${record._createdBy.lastname} (${record._createdBy.email})`
            : 'Sistema'}
        </td>
        <td>
          <span
            className={classnames('badge', {
              'badge-success': record.status === 'ACCEPTED',
              'badge-warning': record.status === 'PENDING',
              'badge-danger': record.status === 'REJECTED',
            })}
          >
            {t(`assets.fields.historics.statusName.${record.status}`)}
          </span>
        </td>
        <td className="text-center">
          <a
            className={classnames('btn btn-outline-success btn-sm mx-2')}
            href="#expand"
            onClick={(e) => {
              e.preventDefault();
              handleToggleCollapsed();
            }}
          >
            {t(!collapsed ? 'assets.fields.historics.hide' : 'assets.fields.historics.show')}
            &nbsp;
            <i
              className={classnames('fa', {
                'fa-angle-down': collapsed,
                'fa-angle-up': !collapsed,
              })}
            />
          </a>

          {record.status === 'PENDING' && (
            <a
              className={classnames('btn btn-outline-danger btn-sm mx-1', {
                'is-loading': isSaving,
              })}
              href={'#reject-historic'}
              onClick={(e) => {
                e.preventDefault();
                handleReject(record);
              }}
            >
              {t('actions.reject')}
            </a>
          )}
          {record.status === 'PENDING' && (
            <a
              className={classnames('btn btn-outline-primary btn-sm mx-1', {
                'is-loading': isSaving,
              })}
              href={'#accept-historic'}
              onClick={(e) => {
                e.preventDefault();
                handleAccept(record);
              }}
            >
              {t('actions.accept')}
            </a>
          )}
        </td>
      </tr>
      <tr className={classnames('table-active', { 'd-none': collapsed })}>
        <td colSpan="7">
          <div className="table-reponsive position-relative">
            <table className="table table-condensed">
              <thead>
                {/* <tr className="text-center">
                <th colSpan="4">{t('reports.employeesAssets.assigned')}</th>
              </tr> */}
                <tr>
                  <th width="20%">{t('assets.fields.historics.field')}</th>
                  <th width="40%">{t('assets.fields.historics.before')}</th>
                  <th width="40%">{t('assets.fields.historics.after')}</th>
                </tr>
              </thead>
              <tbody>
                {record.differences.map((diff, index) =>
                  diff.field === 'location' ? (
                    <tr key={index}>
                      <td>{t(`assets.fields.${diff.field}`)}</td>
                      <td
                        dangerouslySetInnerHTML={{
                          __html: diff.before
                            .split('.')
                            .map((p) => locations[p] && locations[p].name)
                            .filter((l) => l)
                            .join(' <br/> '),
                        }}
                      />
                      <td
                        dangerouslySetInnerHTML={{
                          __html: locationParser(diff.after, diff),
                        }}
                      />
                    </tr>
                  ) : diff.field === 'files' ? (
                    <tr key={index}>
                      <td>
                        {t(`assets.fields.${diff.field}`, {
                          defaultValue: diff.field,
                        })}
                      </td>
                      <td
                        dangerouslySetInnerHTML={{
                          __html: diff.before.split(', ').join(' <br/>'),
                        }}
                      />
                      <td
                        dangerouslySetInnerHTML={{
                          __html: diff.after.split(', ').join(' <br/>'),
                        }}
                      />
                    </tr>
                  )
                  : diff.field === 'bills' ? (
                    <tr key={index}>
                      <td>
                        {t(`assets.fields.${diff.field}`, {
                          defaultValue: diff.field,
                        })}
                      </td>
                      <td
                        dangerouslySetInnerHTML={{
                          __html: diff.before.split(', ').join(' <br/>'),
                        }}
                      />
                      <td
                        dangerouslySetInnerHTML={{
                          __html: diff.after.split(', ').join(' <br/>'),
                        }}
                      />
                    </tr>
                  )
                   : diff.field === 'notes' ? (
                    <tr key={index}>
                      <td>
                        {t(`assets.fields.${diff.field}.text`, {
                          defaultValue: diff.field,
                        })}
                      </td>
                      <td
                        dangerouslySetInnerHTML={{
                          __html: diff.before.split(', ').join(' <br/>'),
                        }}
                      />
                      <td
                        dangerouslySetInnerHTML={{
                          __html: diff.after.split(', ').join(' <br/>'),
                        }}
                      />
                    </tr>
                  ) : (
                    <tr key={index}>
                      <td>
                        {t(`assets.fields.${diff.field}`, {
                          defaultValue: diff.field || '-',
                        })}
                      </td>
                      <td>
                        {t(
                          typeof diff.before === 'boolean'
                            ? diff.before
                              ? 'common.yes'
                              : 'common.no'
                            : typeof diff.before === 'string'
                            ? diff.before
                            : JSON.stringify(diff.before)
                        )}
                      </td>
                      <td>
                        {t(
                          typeof diff.after === 'boolean'
                            ? diff.after
                              ? 'common.yes'
                              : 'common.no'
                            : typeof diff.after === 'string'
                            ? diff.after
                            : JSON.stringify(diff.after)
                        )}
                      </td>
                    </tr>
                  )
                )}
              </tbody>
            </table>
          </div>
        </td>
      </tr>
    </Fragment>
  );
};

export default translate()(AssetFormHistoricRow);



// WEBPACK FOOTER //
// src/components/assets/form_sections/AssetFormHistoricsRow.js